import {
  Row,
  Col,
  Card,
  Table,
  Tabs,
  Select,
  Tooltip,
  Button,
  Image,
} from "antd";
import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
import moment from "moment";
import { AppStateContext } from "../../context/AppContext";
import ShowVideoModal from "../../modals/ShowVideoModal";
import notfound from "../../assets/images/not_found.png";
import deleteWhiteIcon from "../../assets/images/icon/deleteWhiteIcon.png";
import DeleteModal from "../../components/DeleteModal";

const { TabPane } = Tabs;

function ViewProgress() {
  const heading = "User Challenges";
  const { setPageHeading } = useContext(AppStateContext);
  const params = useParams();
  const { request } = useRequest();
  const location = useLocation();
  const challengeData = location.state.data;
  const [loading, setLoading] = useState(false);
  const [challengeHistory, setChallengeHistory] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [mediaLoading, setMediaLoading] = useState(false);
  const [challengeMedia, setChallengeMedia] = useState([]);
  const [selectedTab, setSelectedTab] = useState(
    challengeData?.challenger?._id
  );
  const [mediaPagination, setMediaPagination] = useState({
    current: 1,
    pageSize: 10,
  });
  const [showVideo, setShowVideo] = useState(false);
  const [deleteModal, showDeleteModal] = useState(false);
  const [challengeJrHistory, setChallengeJrHistory] = useState([]);
  const [selected, setSelected] = useState();

  const onDelete = (id) => {
    setMediaLoading(true);
    request({
      url: apiPath.getUserChallenges + "/media-content/" + id,
      method: "DELETE",
      onSuccess: (data) => {
        setMediaLoading(false);
        ShowToast(data.message, Severty.SUCCESS);
        setRefresh((prev) => !prev);
      },
      onError: (error) => {
        console.log(error);
        setMediaLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const columns = [
    {
      title: "Day",
      dataIndex: "day",
      key: "day",
      width: 200,
      // sorter: (a, b) => a.challenge?.localeCompare(b.challenge),
      render: (_, { day }) => {
        return day || "1";
      },
    },
    {
      title: "Checked-In",
      dataIndex: "checked_in",
      key: "checked_in",
      // sorter: (a, b) => a.challenge?.localeCompare(b.challenge),
      render: (_, { checked_in }) => {
        return !!checked_in ? "CheckedIn" : "Missed";
      },
    },
    {
      title: "Emoji",
      dataIndex: "emoji",
      key: "emoji",
      // sorter: (a, b) => a.challenge?.localeCompare(b.challenge),
      render: (_, { emoji }) => {
        return emoji ? emoji : "-";
      },
    },
    {
      title: "Checked-In At",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return moment(created_at).format("ll");
      },
    },
  ];

  const mediaColumns = [
    {
      title: "src",
      dataIndex: "url",
      key: "url",
      render: (_, { url, type }) =>
        type === "Video" ? (
          <video
            className="table-img"
            width={50}
            src={url}
            onClick={() => {
              setSelected(url);
              setShowVideo(true);
            }}
          />
        ) : (
          <Image width={50} src={url ? url : notfound} className="table-img" />
        ),
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      sorter: (a, b) => a?.title?.localeCompare(b?.title),
      sortDirections: ["ascend", "descend"],
      render: (_, { title }) => {
        return title ? <span className="cap">{title}</span> : "-";
      },
    },

    {
      title: "Created On",
      key: "created_at",
      dataIndex: "created_at",

      render: (_, { created_at }) => {
        return moment(created_at).format("DD-MMM-YYYY");
      },
    },

    {
      title: "Action",
      fixed: "right",
      key: "action",
      render: (_, record) => {
        return (
          <div div className="d-flex justify-contenbt-start">
            <Tooltip title={"Delete"} color={"purple"} key={"Delete"}>
              <Button
                title={"Delete"}
                className="btnStyle deleteDangerbtn"
                onClick={() => {
                  setSelected(record);
                  showDeleteModal(true);
                }}
              >
                <img src={deleteWhiteIcon} />
                {/* <span>{"Delete"}</span> */}
              </Button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const handleTabChange = (key) => {
    setSelectedTab(key);
  };

  const getChallengeHistory = (id, user) => {
    setLoading(true);
    request({
      url: apiPath.getUserChallengeHistory + `/${id}` + `?user_id=${user}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        if (data?.statusText == "true") {
          setChallengeHistory(data?.data?.list);
        } else {
          ShowToast(data?.message, Severty.ERROR);
        }
      },
      onError: (err) => {
        ShowToast(err?.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const getChallengeJourneyHistory = (id, user) => {
    setLoading(true);
    request({
      url: apiPath.getUserChallengeJRHistory + `/${id}` + `/${user}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        if (data?.statusText == "true") {
          setChallengeJrHistory(data?.data);
        } else {
          ShowToast(data?.message, Severty.ERROR);
        }
      },
      onError: (err) => {
        // ShowToast(err?.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const fetchMediaData = (pagination, filters, sorter) => {
    const filterActive = filters ? filters.is_active : null;
    setMediaLoading(true);
    request({
      url:
        apiPath.getUserChallenges +
        `/media-content/${params.id}?status=${
          filterActive ? filterActive.join(",") : ""
        }&page=${pagination ? pagination.current : 1}&pageSize=${
          pagination ? pagination.pageSize : 10
        }`,
      method: "GET",
      onSuccess: ({ data }) => {
        setMediaLoading(false);
        setLoading(false);
        setChallengeMedia(data?.data);
        setMediaPagination(() => ({
          current: data?.data?.page,
          pageSize: data?.data?.pageSize,
          total: data?.data?.total,
        }));
      },
      onError: (error) => {
        console.log(error);
        setMediaLoading(false);

        ShowToast(error, Severty.ERROR);
      },
    });
  };

  useEffect(() => {
    if (!params.id && !selectedTab) return;
    getChallengeJourneyHistory(params.id, selectedTab);
    getChallengeHistory(params.id, selectedTab);
    // fetchMediaData()
  }, [params.id, refresh]);

  useEffect(() => {
    setPageHeading(heading);
  }, [setPageHeading]);

  return (
    <>
      <Card className="mt-3">
        <div className="tabled">
          <Row gutter={[24, 0]}>
            <Col xs={24} xl={24}>
              <Tabs
                className="main_tabs"
                onTabClick={handleTabChange}
                activeKey={selectedTab}
                tabBarStyle={{ color: "green" }}
              >
                <TabPane
                  className="tab-btn"
                  tab="Challenger"
                  key={challengeData?.challenger?._id}
                >
                  <Card className="mt-3">
                    <div className="view-main-list">
                      <div class="view-inner-cls">
                        <h5>Challenge:</h5>
                        <h6>
                          <span class="cap">
                            {
                              challengeData?.challenger_challenge?.challenge_id
                                ?.title
                            }
                          </span>
                        </h6>
                      </div>
                      <div class="view-inner-cls">
                        <h5>Name:</h5>
                        <h6>
                          <span class="cap">
                            {challengeData?.challenger?.name}
                          </span>
                        </h6>
                      </div>
                      <div class="view-inner-cls">
                        <h5>Email:</h5>
                        <h6>
                          <span class="cap">
                            {challengeData?.challenger?.email}
                          </span>
                        </h6>
                      </div>
                      <div class="view-inner-cls">
                        <h5>Current Day:</h5>
                        <h6>
                          <span class="cap">
                            {challengeHistory?.length || 0}
                          </span>
                        </h6>
                      </div>
                      <div class="view-inner-cls">
                        <h5>Total CheckIns:</h5>
                        <h6>
                          <span class="cap">
                            {challengeJrHistory?.checkedInCount || 0}
                          </span>
                        </h6>
                      </div>
                      <div class="view-inner-cls">
                        <h5>Total Skips:</h5>
                        <h6>
                          <span class="cap">
                            {challengeJrHistory?.skippedCount || 0}
                          </span>
                        </h6>
                      </div>
                      <div class="view-inner-cls">
                        <h5>Total Emotion Checked-In:</h5>
                        <h6>
                          <span class="cap">
                            {challengeJrHistory?.checkedInEmotionCount || 0}
                          </span>
                        </h6>
                      </div>
                    </div>
                  </Card>
                </TabPane>
                <TabPane
                  className="tab-btn"
                  tab="Partner 1"
                  key={challengeData?.receiver?._id}
                >
                  <Card className="mt-3">
                    <div className="view-main-list">
                      <div class="view-inner-cls">
                        <h5>Challenge:</h5>
                        <h6>
                          <span class="cap">
                            {
                              challengeData?.receiver_challenge?.challenge_id
                                ?.title
                            }
                          </span>
                        </h6>
                      </div>
                      <div class="view-inner-cls">
                        <h5>Name:</h5>
                        <h6>
                          <span class="cap">
                            {challengeData?.receiver?.name}
                          </span>
                        </h6>
                      </div>
                      <div class="view-inner-cls">
                        <h5>Current Day:</h5>
                        <h6>
                          <span class="cap">
                            {challengeHistory?.length || 0}
                          </span>
                        </h6>
                      </div>
                      <div class="view-inner-cls">
                        <h5>Total CheckIns:</h5>
                        <h6>
                          <span class="cap">
                            {challengeJrHistory?.checkedInCount || 0}
                          </span>
                        </h6>
                      </div>
                      <div class="view-inner-cls">
                        <h5>Total Skips:</h5>
                        <h6>
                          <span class="cap">
                            {challengeJrHistory?.skippedCount || 0}
                          </span>
                        </h6>
                      </div>
                      <div class="view-inner-cls">
                        <h5>Total Emotion Checked-In:</h5>
                        <h6>
                          <span class="cap">
                            {challengeJrHistory?.checkedInEmotionCount || 0}
                          </span>
                        </h6>
                      </div>
                    </div>
                  </Card>
                </TabPane>
                {/* <TabPane className="tab-btn" key={3} tab="Receiver 3">
                  <Card className="mt-3">
                    <div className="view-main-list">
                      <div class="view-inner-cls">
                        <h5>Name:</h5>
                        <h6>
                          <span class="cap">I Phone 16 Pro</span>
                        </h6>
                      </div>
                      <div class="view-inner-cls">
                        <h5>Name:</h5>
                        <h6>
                          <span class="cap">I Phone 16 Pro</span>
                        </h6>
                      </div>
                      <div class="view-inner-cls">
                        <h5>Name:</h5>
                        <h6>
                          <span class="cap">I Phone 16 Pro</span>
                        </h6>
                      </div>
                    </div>
                  </Card>
                </TabPane> */}
              </Tabs>
            </Col>
          </Row>
        </div>
      </Card>
      <Card
        className="criclebox tablespace mb-24 mt-3"
        title={"User Challenges"}
      >
        <div className="table-responsive customPagination">
          <Table
            className="ant-border-space main-table"
            loading={loading}
            columns={columns}
            dataSource={challengeHistory}
            pagination={true}
          />
        </div>
      </Card>
      {/* <Card
        className="criclebox tablespace mb-24 mt-3"
        title={"User Challenges Media"}
      >
        <div className="table-responsive customPagination">
          <Table
            className="ant-border-space main-table"
            loading={mediaLoading}
            columns={mediaColumns}
            dataSource={challengeMedia}
            pagination={{
              current: mediaPagination?.current,    
              defaultPageSize: 10,
              responsive: true,
              total: mediaPagination?.total,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["10", "20", "30", "50"],
            }}
          />
        </div>
      </Card> */}

      <Card className="mt-3">
        <h4>Head 2 Head Comparision</h4>
        <div style={{ padding: "25px" }}>
          <Row gutter={[24, 0]}>
            {/* <WeeklyChartSection borderColor="#1EB564" /> */}
          </Row>
        </div>
      </Card>
      {showVideo && (
        <ShowVideoModal
          show={showVideo}
          hide={() => {
            setShowVideo(false);
            setSelected();
          }}
          data={selected}
          onOk={() => {
            setShowVideo(false);
            setSelected();
          }}
        />
      )}
      {deleteModal && (
        <DeleteModal
          reasons={[]}
          title={"Delete Content"}
          subtitle={`Are you sure you want to Delete this Content?`}
          show={deleteModal}
          hide={() => {
            showDeleteModal(false);
            setSelected();
          }}
          onOk={() => onDelete(selected?._id)}
        />
      )}
    </>
  );
}

export default ViewProgress;
